import { TenantTerm, tenantTerm } from '../types/customerType';
import { useCustomerType } from './useCustomerType';

/** The instance's word for tenants ("Medlem / hyresgäst" in a BRF); "Hyresgäst" while loading. */
export function useTenantTerm(): TenantTerm {
    return tenantTerm(useCustomerType());
}
